export default __webpack_public_path__ + "static/media/arrow_down_chevron_icon.eccfb3df.svg";